// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { useMemo } from "react";

import { useField } from "formik";

import { getFieldTestId } from "utils/formik";

import { createMixedValidator } from ".";
import { Input } from "../elements";
import { FieldProps } from "./propTypes";

export const TextField = (props) => {
  const { name, required = true, dataTestId, validate: validateFn } = props;

  const validate = useMemo(
    () => createMixedValidator(name, required, validateFn),
    [name, required, validateFn]
  );

  const [field, meta] = useField({
    ...props,
    required,
    type: "text",
    validate,
  });

  return (
    <Input
      {...meta}
      {...props}
      props={field}
      required={required}
      dataTestId={dataTestId || getFieldTestId(name)}
    />
  );
};

TextField.propTypes = FieldProps;
